import React from "react";
import { BrowserRouter as Router } from "react-router-dom";
import { LoadScript } from "@react-google-maps/api";
import { AuthProvider } from "../contexts/AuthContext";
import ErrorBoundary from "../components/error/ErrorBoundary";
import FeedbackButton from "../components/feedback/FeedbackButton";
import { AppRoutes } from "../routes";
import "../theme/App.css";
import { LoaderProvider } from "../contexts/LoaderContext";
import GlobalLoader from "../components/GlobalLoader/GlobalLoader";
import ReleaseNoteModal from "../components/ReleaseNoteModal/index";
import SessionExpiredDialog from "../components/SessionExpiredDialog/index";

function App() {
  return (
    <LoaderProvider>
      <ErrorBoundary>
        <LoadScript
          googleMapsApiKey={process.env.REACT_APP_GOOGLE_MAPS_API_KEY}
          libraries={["places", "geometry", "marker"]}
        >
          <Router>
            <div className="app-container">
              <AppRoutes />
              <FeedbackButton />
              {/* <ReleaseNoteModal /> */}
              <GlobalLoader />
              {/* <SessionExpiredDialog /> */}
            </div>
          </Router>
        </LoadScript>
      </ErrorBoundary>
    </LoaderProvider>
  );
}

export default App;
